import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { RequestResult } from '../../models';
import { RequestResultType } from '../../enums/request-result-type';
import { LogService } from '../logging/log.service';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import * as _ from 'lodash';

@Injectable()
export abstract class BaseRestApiService {
    constructor(private http: HttpClient, private logService: LogService) { }

    protected get(relativeUrl: string): Observable<any> {
        this.logService.debug('GET ' + relativeUrl, undefined);
        return this.http.get(relativeUrl)
            .map((res: any) => new RequestResult(RequestResultType.Success, res))
            .catch((res: any): Observable<RequestResult<any>> => {
                return this.handleError(res, relativeUrl);
            });
    }

    protected post(relativeUrl: string, data?: any, headers?: HttpHeaders): Observable<RequestResult<any>> {
        this.logService.debug('POST ' + relativeUrl, undefined);
        return this.http.post(relativeUrl, data, this.setRequestOptions(headers))
            .map((res: any) => new RequestResult(RequestResultType.Success, res))
            .catch((res: any): Observable<RequestResult<any>> => {
                return this.handleError(res, relativeUrl);
            });
    }

    protected delete(relativeUrl: string, data?: any, headers?: HttpHeaders): Observable<RequestResult<any>> {
        this.logService.debug('DELETE ' + relativeUrl, data);
        return this.http.delete(relativeUrl, this.setRequestOptions(headers))
            .map((res: any, test: any) => new RequestResult(RequestResultType.Success, res))
            .catch((res: any): Observable<RequestResult<any>> => {
                return this.handleError(res, relativeUrl);
            });
    }

    protected put(relativeUrl: string, data?: any, headers?: HttpHeaders): Observable<RequestResult<any>> {
        this.logService.debug('PUT ' + relativeUrl, data);
        return this.http.put(relativeUrl, data, this.setRequestOptions(headers))
            .map((res: any) => new RequestResult(RequestResultType.Success, res))
            .catch((res: any): Observable<RequestResult<any>> => {
                return this.handleError(res, relativeUrl);
            });
    }

    protected request(relativeUrl: string, headers?: HttpHeaders): Observable<RequestResult<any>> {
        this.logService.debug('REQUEST GET ' + relativeUrl, undefined);
        return this.http.get(relativeUrl, this.setRequestOptions(headers))
            .map((res: any) => new RequestResult(RequestResultType.Success, res))
            .catch((res: any): Observable<RequestResult<any>> => {
                return this.handleError(res, relativeUrl);
            });
    }

    private setRequestOptions(header?: HttpHeaders): { headers: HttpHeaders } {
        const headers: HttpHeaders = header || new HttpHeaders();
        if (!headers.has('Content-Type')) {
            headers.append('Content-Type', 'application/json');
        }

        return { headers };
    }

    public handleError(response: any, url: string): Observable<RequestResult<any>> {
        let requestResultType: RequestResultType;
        switch (response.status) {
            case 0: requestResultType = RequestResultType.NoConnection; break;
            case 404: requestResultType = RequestResultType.NotFound; break;
            default:
                if (response.status >= 400 && response.status < 500) {
                    if (response.error && _.toLower(response.error.error) === 'invalid_grant') {
                        requestResultType = RequestResultType.InvalidCredentials;
                    } else {
                        requestResultType = RequestResultType.BadRequest;
                    }
                } else {
                    requestResultType = RequestResultType.ServerError;
                }
                break;
        }

        this.logService.error('HTTP Error : ' + url, response);
        return Observable.of(new RequestResult(requestResultType));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/base/base-rest.api.service.ts